import { Component, Input } from '@angular/core';
import { ReactiveFormsModule, FormControl, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs';
import { MinorEditsService } from '../../../../services/minor-edits.service';

@Component({
  selector: 'app-components-shared-minor-edits-order',
  templateUrl: './minor-edits-order.component.html'
})
export class MinorEditsOrderComponent {
  @Input() customerId: number;
  @Input() websiteUrlId: number;

  isSubmitting = false;
  descriptionCtrl = new FormControl<string>('', [MinorEditsOrderComponent.requiredDescription, Validators.maxLength(2000)]);

  private static requiredDescription(control: AbstractControl): ValidationErrors | null {
    return control.value?.trim() ? null : { required: { alternateMessage: 'Description is required' } };
  }

  constructor(
    public activeModal: NgbActiveModal,
    private minorEditsService: MinorEditsService
  ) { }

  submit(): void {
    if (this.descriptionCtrl.invalid) {
      this.descriptionCtrl.markAsTouched();
      return;
    }

    this.isSubmitting = true;
    this.minorEditsService.order(this.customerId, this.descriptionCtrl.value, this.websiteUrlId)
      .pipe(finalize(() => this.isSubmitting = false))
      .subscribe({
        next: () => {
          toastr.success('Minor Edits order submitted successfully.');
          this.activeModal.close();
        },
        error: err => toastr.error(err)
      });
  }
}
